@if (field?.state$ | async) {
  <div [formGroup]="form">
    @if (field.counties.length > 1) {
      <mat-form-field appearance="outline" class="w-full">
        <mat-label [class.disabled]="form.disabled">{{ label }}</mat-label>
        <mat-select
          placeholder="Please Select"
          [value]="field.selectedFips"
          [disabled]="form.disabled"
          (selectionChange)="field.select($event.value)"
        >
          @for (county of field.counties; track county.countyFIPS) {
            <mat-option [value]="county.countyFIPS"
              >{{ county.countyName }} ({{ county.state.abbreviation }})</mat-option
            >
          }
        </mat-select>
        <mat-hint>Please select your county from the list above</mat-hint>
      </mat-form-field>
    } @else {
      <app-boomer-text-input [form]="form" [formControlName]="countyControlName" [label]="label" readonly />
    }
    @if (field.state.status === 'loading') {
      <mat-progress-bar mode="indeterminate" />
    }
    @if (field.state.status === 'lookupFailed') {
      <button
        type="button"
        class="relative -mt-4 ml-4 block cursor-pointer border-0 bg-transparent p-0 text-sm text-[#2c67ff] underline underline-offset-2 disabled:cursor-default disabled:text-gray-500"
        [disabled]="form.disabled"
        (click)="field.retry()"
      >
        Retry county lookup
      </button>
    }
  </div>
}
